import PropTypes from 'prop-types';
import { StatisticsLayout } from 'views/components';
import isEmpty from 'lodash/isEmpty';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    BarChart,
    Card,
    Container,
    InfoCard,
    PageController,
    Table
} from 'mol-ui';
import {
    Col,
    Row
} from 'reactstrap';
import {
    DOWNLOAD_HEADERS,
    HEADERS
} from './fixtures';
import React, { useState } from 'react';
import {
    clearObject,
    isLocked,
    toggleElementArray
} from 'shared/utils';

import {
    useDispatch,
    useSelector
} from 'hooks';

const DiagnosisGeneral = ({
    tabController
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user } = useSelector('account');
    const {
        riskFactors,
        riskFactorsDownload,
        riskFactorsDownloading,
        riskFactorsPage,
        riskFactorsPageLoading,
        loading
    } = useSelector('statistics');

    const [selectedRiskFactors, setSelectedRiskFactors] = useState([]);
    const [lastFilters, setLastFilters] = useState({});

    const composeFilters = filters => clearObject(({
        ...filters,
        risk_factor_ids: selectedRiskFactors.map(rf => Number(rf))
    }), true);

    const onRiskFactorClick = ({ key }) => {
        const newSelectedRiskFactors = toggleElementArray(selectedRiskFactors, key);
        setSelectedRiskFactors(newSelectedRiskFactors);
        dispatch(statisticsActions.getStatisticsRiskFactorsPage({
            ...lastFilters,
            risk_factor_ids: newSelectedRiskFactors.map(rf => Number(rf))
        }));
    };

    const onFiltersChange = filters => {
        setLastFilters(filters);
        dispatch(statisticsActions.getStatisticsRiskFactors(clearObject(filters, true)));
        dispatch(statisticsActions.getStatisticsRiskFactorsPage(composeFilters(filters)));
    };

    const downloadController = {
        data: riskFactorsDownload,
        downloading: riskFactorsDownloading,
        fileName: t('Factores de riesgo'),
        headers: DOWNLOAD_HEADERS,
        onDownload: filters => dispatch(statisticsActions.getStatisticsRiskFactorsDownload(composeFilters(filters)))
    };

    const { data: riskFactorsData } = riskFactorsPage ? riskFactorsPage.getData() : { data: [] };
    const totalPatients = riskFactorsPage?.total;
    
    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            filterDates={ false }
            filterPatients={ ['area', 'cost_center', 'hr_head', 'position', 'workplace'] }
            filterProfessionals={ false }
            filterSpecialties={ false }
            loading={ loading }
            tabController={ tabController }
            onFiltersChange={ onFiltersChange }
        >
            <Container>
                {
                    !isEmpty(riskFactors) &&
                    <Card
                        overflowX="auto"
                        overflowY="auto"
                        padding="20px 10px 0px 0px"
                        title={ t('Factores de riesgo') }
                    >
                        <BarChart
                            vertical
                            config={ [{ dataKey: 'patients', label: t('Factor de riesgo') }] }
                            data={ riskFactors }
                            disabled={ riskFactorsPageLoading }
                            minWidth={ 700 }
                            selected={ selectedRiskFactors }
                            xAxisVerticalHeight={ 100 }
                            onClick={ onRiskFactorClick }
                        />
                    </Card>
                }
                {
                    !!totalPatients &&
                    <>
                        <Row>
                            <Col md="6" xs="12">
                                <InfoCard
                                    caption={ t('Total de pacientes') }
                                    icon="people"
                                    margin="0px"
                                    title={ totalPatients?.toString() }
                                />
                            </Col>
                        </Row>
                        <Table
                            config={ HEADERS }
                            data={ riskFactorsData }
                            loading={ riskFactorsPageLoading }
                        />
                        <PageController
                            controller={ riskFactorsPage }
                            height="40px"
                        />
                    </>
                }
            </Container>
        </StatisticsLayout>
    );
};

DiagnosisGeneral.propTypes = {
    tabController: PropTypes.object
};

export default DiagnosisGeneral;
